import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import PageHeader from '../../../shared/page-header/components/page-header';
import DefaultLoader from '../../../shared/default-loader/components/default-loader';
import RenderIf from '../../../shared/render-if/components/render-if';
import EmptyState from '../../../shared/empty-state/components/empty-state';
import CreateCampaignModal from '../../campaigns/components/create-campaign-modal';
import ChooseCampaignModal from '../../campaigns/components/choose-campaign-modal';
import MobileCampaignModal from '../../campaigns/components/mobile-campaign-modal';
import LinkCreatorSelectors from './link-creator-selectors';
import LinkDisplay from './link-display';
import { getCampaigns } from '../../campaigns/actions/campaigns-actions';
import { toggleChooseCampaignModal } from '../../campaigns/actions/campaigns-actions';
import { getSites } from '../../link-creator/actions/link-creator-actions';

class LinkCreator extends Component {
  componentDidMount() {
    const { campaigns, getCampaigns, sites, getSites } = this.props;

    if (!campaigns) {
      getCampaigns();
    }

    if (!sites) {
      getSites(true);
    }
  }

  openChooseCampaignModal() {
    const { toggleChooseCampaignModal } = this.props;

    toggleChooseCampaignModal(true);
  }

  render() {
    const { httpInProgress, campaigns, campaign, language, profile } = this.props;

    return (
      <div className="link-creator-container p-b-30">
        <ChooseCampaignModal />
        <CreateCampaignModal />
        <MobileCampaignModal />
        <PageHeader title={'LINK_CREATOR.TITLE'} />
        <RenderIf if={httpInProgress}>
          <div className="display-flex-center p-b-50 p-t-50">
            <DefaultLoader />
          </div>
        </RenderIf>
        <RenderIf if={campaigns && campaigns.length > 0 && profile}>
          <div className="activity-summary-container">
            <LinkCreatorSelectors />
            <RenderIf if={campaign && language}>
              <div className="row display-flex-center p-l-15 p-r-15 m-t-20">
                <div className="col-md-6 col-sm-12">
                  <LinkDisplay />
                </div>
              </div>
            </RenderIf>
          </div>
        </RenderIf>
        <RenderIf if={campaigns && campaigns.length === 0}>
          <EmptyState title={'CAMPAIGNS.NO_CAMPAIGNS_MESSAGE'} actionButtonLabel={'CAMPAIGNS.CREATE_FIRST_CAMPAIGN'} callback={this.openChooseCampaignModal.bind(this)} />
        </RenderIf>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  campaigns: state.campaignsReducer.campaigns,
  httpInProgress: state.httpInProgressReducer.httpInProgress,
  campaign: state.linkCreatorReducer.campaign,
  language: state.linkCreatorReducer.language,
  profile: state.userProfileReducer.profile,
  sites: state.linkCreatorReducer.sites,
});

const mapDispatchToProps = dispatch => ({
  getCampaigns: () => {
    dispatch(getCampaigns());
  },
  toggleChooseCampaignModal: show => {
    dispatch(toggleChooseCampaignModal(show));
  },
  getSites: (active, pageCode) => {
    dispatch(getSites(active, pageCode));
  },
});

LinkCreator.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(LinkCreator);



// WEBPACK FOOTER //
// ./src/app/main/link-creator/components/link-creator.js